import Header from "./Layout/Header";
import LeftSideBar from "./Layout/LeftSideBar";
import { NavLink } from "react-router-dom";
import { trans } from "./utils";
import React, { useState, useEffect } from 'react';
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux'
import config from '../config.js';

const Template = (data) => {
    const SystemUrl = config.SystemUrl;
    const minimize = useSelector((state) => state.menuToggle.minimize)

    const $ = require("jquery");

    //Render Component
    var ComponentToRender = require('./' + data.getfolder + '/' + data.getaction).default;
    //Get Module Variables FROM API
    let GetModuleData = JSON.parse(localStorage.getItem(data.getmodule)) || data.getmodule;
    let module_name = data.getmodule;
    if (GetModuleData && GetModuleData.role_id != 0) {
        module_name = GetModuleData.module_name
    }
    const [file, setFile] = useState(null);

    const [isDisabled, setDisabled] = useState(false);

    const UploadExcel = () => {
        setDisabled(true);
        let formData = new FormData();
        formData.append("file", file);
        //general excel import
        axios.post(SystemUrl + data.getmodule + '/import', formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }).then(res => {
            $("#datatable").DataTable().ajax.reload()
            toast.success('Success');
            setDisabled(false);
        }).catch((err) => {
            setDisabled(false);
            // console.log(err.response.data.message);
            var error = ""
            err.response.data.message.forEach(el => {
                error += (el + "\n\r\t")
            })
            // toast(error)
            toast.error(error, { position: toast.POSITION.UPPER_RIGHT });

        });

        // axios.post(SystemUrl + data.getmodule + '/import',)
    }
    //Dashboard Has no Variables
    if (!GetModuleData) {
        GetModuleData = {}
        GetModuleData.name_en = 'Dashboard';
    }
    let SystemTitle = localStorage.getItem('SystemTitle') ? localStorage.getItem('SystemTitle') : "HIC - AEON";
    let PageModuleTitle = trans(GetModuleData.name_en) ? trans(GetModuleData.name_en) : "Dashboard";

    const folder = data.getfolder
    useEffect(() => {
        document.title = SystemTitle + " | " + PageModuleTitle + " - " + data.getaction
        window.$('.tooltip').tooltip('hide');
        window.$('[data-toggle="tooltip"]').tooltip();
    })
    return (

        <div id="kt_body" data-kt-aside-minimize={minimize} className="header-fixed header-tablet-and-mobile-fixed toolbar-enabled toolbar-fixed toolbar-tablet-and-mobile-fixed aside-enabled aside-fixed">
            {folder != "FormBuilder" ? (
                <div className="header-fixed header-tablet-and-mobile-fixed toolbar-enabled toolbar-fixed toolbar-tablet-and-mobile-fixed aside-enabled aside-fixed">
                    <div className="d-flex flex-column flex-root">
                        <div className="page d-flex flex-row flex-column-fluid">
                            <LeftSideBar ></LeftSideBar>
                            <div className="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
                                <Header />
                                <div className="content d-flex flex-column flex-column-fluid" id="kt_content">
                                    <div className="toolbar" id="kt_toolbar">

                                        <div id="kt_toolbar_container" className="container-fluid d-flex flex-stack">

                                            <div data-kt-place="true" data-kt-place-mode="prepend"
                                                data-kt-place-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
                                                className="page-title d-flex align-items-center me-3 flex-wrap mb-5 mb-lg-0 lh-1">

                                                <h1 className="d-flex align-items-center text-dark fw-bolder my-1 fs-3">{trans(GetModuleData.name_en)}</h1>

                                                <span className="h-20px border-gray-200 border-start mx-4"></span>

                                                <ul className="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">

                                                    <li className="breadcrumb-item text-muted">
                                                        <NavLink to='/dashboard'
                                                            className="text-muted text-hover-primary">{trans('Dashboard')}</NavLink>
                                                    </li>

                                                    <li className="breadcrumb-item text-dark">{trans(GetModuleData.name_en)}</li>

                                                </ul>

                                            </div>
                                          
                                            {!!GetModuleData.add && !!GetModuleData.page_add && data.getaction != 'Add' && !(localStorage.getItem('userRole') == 34 && GetModuleData.name_en =="MyAsset") ?

                                                <div className="d-flex align-items-center py-1">

                                                    <div className="me-4">
                                                        <NavLink to={`/${data.getmodule}/Add`}
                                                            className="btn btn-light-primary font-weight-bold mr-2"
                                                            data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end"
                                                            data-kt-menu-flip="top-end"
                                                            data-container="body" data-toggle="tooltip" data-placement="bottom" title={trans(GetModuleData.name_en)}
                                                        >
                                                            <i className="bi bi-plus fs-3"></i> {trans('Create')}
                                                            {/*{trans(GetModuleData.name_en)}*/}
                                                        </NavLink>
                                                    </div>

                                                    <div className="me-4" data-container="body" data-toggle="tooltip" data-placement="bottom" title={trans(GetModuleData.name_en)}>

                                                        <button type="button" className="btn btn-primary align-self-center" data-toggle="modal" data-target="#AssignModal" >{trans('Upload')}</button>

                                                    </div>

                                                </div>
                                                : <br />
                                            }
                                        </div>

                                    </div>

                                    <div className="modal fade" id="AssignModal" tabIndex="-1" role="dialog"
                                        aria-labelledby="AssignModalLabel" aria-hidden="true">
                                        <div className="modal-dialog" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title" id="exampleModalLabel">{trans('Upload')} {trans(GetModuleData.name_en)} <a href={SystemUrl + data.getmodule + '?export=1'} download>{trans('Download Sample')}</a></h5>
                                                    <button type="button" className="close" data-dismiss="modal"
                                                        aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                <div className="modal-body">
                                                    <form>

                                                        <div className="form-group">
                                                            <label htmlFor="message-text"
                                                                className="col-form-label">{trans('Actions options')} :</label>
                                                            <input onChange={e => setFile(e.target.files[0])} type="file" className="form-control" required />
                                                        </div>
                                                        <div className="modal-footer">
                                                            <div className="row">
                                                               
                                                                <div className="col-md-6">
                                                                    <button type="button" className="btn btn-secondary"
                                                                        data-dismiss="modal">{trans('Close')}
                                                                    </button>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <button type="button" onClick={UploadExcel} className="btn btn-primary" disabled={isDisabled}>{trans('Submit')}</button>

                                                                </div>


                                                            </div>

                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="post d-flex flex-column-fluid" id="kt_post">
                                        <div className="container" id="kt_content_container">
                                            <ComponentToRender RoleId={GetModuleData.role_id} CurrentModule={data.getmodule} SystemUrl={SystemUrl} />
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>) :
                <ComponentToRender CurrentModule={data.getmodule} SystemUrl={SystemUrl} />
            }
            <ToastContainer />
        </div>
    )
}
export default Template
